import { writable } from 'svelte/store';

function createRouter() {
  // Parse URL to extract path and query parameters
  const parseUrl = (url) => {
    const parsedUrl = new URL(url, window.location.origin);
    const path = parsedUrl.pathname;
    const searchParams = parsedUrl.searchParams;
    
    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    
    return { path, params };
  };

  // Get initial state from current location
  const initialState = parseUrl(window.location.href);
  
  const { subscribe, set } = writable(initialState);

  const navigate = (url) => {
    // Push the full URL to browser history
    window.history.pushState({}, '', url);
    
    // Update store with parsed path and params
    const { path, params } = parseUrl(url);
    set({ path, params });
    
    // Reset scroll position to top when navigating
    window.scrollTo(0, 0);
  };

  // Handle browser back/forward navigation
  window.addEventListener('popstate', () => {
    const { path, params } = parseUrl(window.location.href);
    set({ path, params });
    // Also reset scroll when using browser back/forward
    window.scrollTo(0, 0);
  });

  return {
    subscribe,
    navigate
  };
}

export const router = createRouter(); 